import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import {
  InboxContainer,
  type InboxSearch,
} from '@/containers/inbox/inbox-container.component';
import { InboxSkeleton } from '@/containers/inbox/inbox-skeleton.component';
import { INBOX_LABELS } from '@/containers/inbox/inbox-search';
import { SequencingPage } from '@/containers/sequences/sequencing-page.component';
import { useSequencingNavigation } from '@/containers/sequences/use-sequencing-navigation.hook';

// The open conversation and the filters live in the URL, so a thread can be
// linked and a refresh lands where the rep was.
const inboxSearchSchema = z.object({
  thread: z.string().optional(),
  // .catch: an unknown value (stale link, typo) falls back instead of
  // throwing, which crashed the whole page ("This page couldn't load").
  view: z
    .enum(['needs', 'all', 'snoozed', 'archived'])
    .optional()
    .catch(undefined),
  sequence: z.string().optional(),
  owner: z.string().optional(),
  sender: z.string().optional(),
  since: z.enum(['week', 'month', 'quarter']).optional().catch(undefined),
  label: z
    .enum([...INBOX_LABELS, 'none'])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/inbox')({
  component: InboxRoute,
  validateSearch: inboxSearchSchema,
});

function InboxRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  const onNavigate = useSequencingNavigation();
  return (
    <SequencingPage title='Inbox' checking={<InboxSkeleton />}>
      <InboxContainer
        search={search}
        onSearchChange={(next: InboxSearch) =>
          void navigate({ to: '/inbox', search: next, replace: true })
        }
        onNavigate={onNavigate}
      />
    </SequencingPage>
  );
}
